var _path, _path2, _path3, _path4, _path5, _ellipse, _path6, _ellipse2, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _circle, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _circle2, _path28, _path29, _path30, _path31, _path32, _ellipse3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDialogPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 148.281,
    height: 182.741,
    viewBox: "0 0 148.281 182.741",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "undraw_file_manager_re_ms29",
    transform: "translate(-48.047 0.001)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14700",
    "data-name": "Trazado 14700",
    d: "M882.527,131.712h1.95c1.494-11.467-10-20.175-23.18-21.238A28.264,28.264,0,0,1,882.527,131.712Z",
    transform: "translate(-693.352 -109.776)",
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14701",
    "data-name": "Trazado 14701",
    d: "M818.484,317.8q-1.655-.02-3.171-.112A13.506,13.506,0,0,0,818.484,317.8Z",
    transform: "translate(-659.649 -261.656)",
    fill: "#f2f2f2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14702",
    "data-name": "Trazado 14702",
    d: "M733.2,136.028a27.594,27.594,0,0,1,27.4-27.4,33.43,33.43,0,0,1,6.245-.076,28.18,28.18,0,0,0-34.417,27.473c0,14.322.513,26.541,22.137,27.866C743.6,162.23,733,147.888,733.2,136.028Z",
    transform: "translate(-598.894 -107.857)",
    fill: "#f2f2f2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14703",
    "data-name": "Trazado 14703",
    d: "M857.2,215c-4.952,8.472-24.423,14.685-27.152,26.956a12.5,12.5,0,0,1-2.864.581c.9.011,1.823.007,2.785-.015A28.1,28.1,0,0,0,858.218,215Z",
    transform: "translate(-668.352 -186.388)",
    fill: "#f2f2f2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14704",
    "data-name": "Trazado 14704",
    d: "M834.059,201.334a46.385,46.385,0,0,1-4.073-25.453,2.128,2.128,0,0,1,1.337-2.4l16.3-4.555a1.618,1.618,0,0,1,1.959,1.483l4.073,25.453a2.127,2.127,0,0,1-1.337,2.4l-16.3,4.555A1.618,1.618,0,0,1,834.059,201.334Z",
    transform: "translate(-670.149 -152.576)",
    fill: "#f2f2f2"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_90",
    "data-name": "Elipse 90",
    cx: 3.32,
    cy: 2.771,
    rx: 3.32,
    ry: 2.771,
    transform: "translate(165.709 21.744) rotate(-82.638)",
    fill: "#f2f2f2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14705",
    "data-name": "Trazado 14705",
    d: "M751.339,154.724a46.385,46.385,0,0,1-4.073-25.453,2.127,2.127,0,0,1,1.337-2.4l16.3-4.555a1.618,1.618,0,0,1,1.959,1.483l4.073,25.453a2.127,2.127,0,0,1-1.337,2.4l-16.3,4.555A1.618,1.618,0,0,1,751.339,154.724Z",
    transform: "translate(-609.519 -118.414)",
    fill: "#f2f2f2"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_91",
    "data-name": "Elipse 91",
    cx: 3.32,
    cy: 2.771,
    rx: 3.32,
    ry: 2.771,
    transform: "translate(143.618 9.297) rotate(-82.638)",
    fill: "#f2f2f2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14707",
    "data-name": "Trazado 14707",
    d: "M355.643,609.86l4-.034,1.771-15.793-5.905.05Z",
    transform: "translate(-260.57 -435.395)",
    fill: "#f9735d"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14708",
    "data-name": "Trazado 14708",
    d: "M596.251,761.206a1.791,1.791,0,0,1-1.774,1.8l-7.955.066-1.9.014-3,.027.758-10.12,1.044-.069,4.26-.294,1.374-.092.024,2.863,6.391,4.335a1.788,1.788,0,0,1,.784,1.465Z",
    transform: "translate(-488.361 -580.379)",
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14709",
    "data-name": "Trazado 14709",
    d: "M477.636,558.519c-1.592-.192-5.608-.534-5.608-.534s-1.9-3.958-1.589-5.189,1.055-1.487.355-2.134c-1.7-6.3-1.431-16.525-1.431-16.525s-9.171-4.441-18.456-9.582c-9.077-5.029-18.264-10.725-19.094-13.6a36.568,36.568,0,0,1-1.1-6.268c-.139-1.389-.224-2.751-.278-3.971-.125-2.793-.075-4.858-.075-4.858l11.571-.192,7.664-.176h.8v1.335l2.014,3.424s3.48,4.046,3.071,4.422c-.494.457-.345.863,1.41,1.194a5.706,5.706,0,0,0,1.512.061c2.833-.216,4.019,1.4,4.089,1.76.475,2.508,5.242,7.956,9.707,12.6h0c4.121,4.294,7.982,7.9,7.982,7.9l.219,4.607,1.028,21.538s-1.928-1.079-.206,1.247S479.228,558.709,477.636,558.519Z",
    transform: "translate(-377.491 -391.976)",
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14710",
    "data-name": "Trazado 14710",
    d: "M498.03,403.632l1.634-3.653L486.038,391.8l-2.411,5.391Z",
    transform: "translate(-354.473 -287.169)",
    fill: "#f9735d"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14711",
    "data-name": "Trazado 14711",
    d: "M775.281,509.8a1.791,1.791,0,0,1,.9,2.363l-3.248,7.262-.779,1.738-1.224,2.741-8.888-4.9.371-.979,1.5-4,.488-1.288,2.614,1.169,6.6-4.009A1.788,1.788,0,0,1,775.281,509.8Z",
    transform: "translate(-620.607 -402.347)",
    fill: "#2f2e41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14712",
    "data-name": "Trazado 14712",
    d: "M543.033,471.458c-.009.021-.02.04-.03.057-.744,1.366-1.966,4.528-2.042,4.723a.03.03,0,0,0,0,.011s-4.031-.208-5.061-.947.53.433-1.85-1.125c-1.231-.81-5.447-2.074-9.223-3.106-3.513-.961-6.643-1.716-6.643-1.716s-2.767,2.518-6.776,6l0,0c-3.724,3.225-8.522,7.281-13.172,10.913-9.955,2.928-20.463,5.465-23.089,4.04a36.569,36.569,0,0,1-5.234-3.62l2.7-7.09,7.153-7.491,7.53-3.06,2.946-1.2,4.125-1.674L516.7,457.1l24.73,8.566s-1.723,1.392,1.081.658C545.272,465.6,543.811,469.993,543.033,471.458Z",
    transform: "translate(-406.485 -363.837)",
    fill: "#2f2e41"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14713",
    "data-name": "Trazado 14713",
    d: "M422.771,356.495h8.012l1.261,2.784,5.365,2.391a4.876,4.876,0,0,1,2.777,3.412c.077.353-2.855,2.862-2.777,3.268A107.245,107.245,0,0,0,435.9,382.6c-.267,9.881,2.048,7.906,2.2,10.345.046.73.492,3.616,1.925,3.345s.661.869,1,1.313c.293.383,1.835-.125.867,1.148s3.169,4.745.635,4.745c-4.807,0-14.421,2.4-18.16,2.4s-6.628,1.109-8.279,1.068c-1.006-.025-.692-4.716-.289-8.779.091-.92,1.858-.9.272-2.6s.281-2.592.284-3.041a4.108,4.108,0,0,0-.218-3.643c-1.117-1.965-.087-1.152-.136-1.769-.374-4.755-.91-10.818-.91-10.818l-2.362-6.647a6.954,6.954,0,0,1,4-8.8l2.77-1.093Z",
    transform: "translate(-364.286 -290.096)",
    fill: "#73554a"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14714",
    "data-name": "Trazado 14714",
    d: "M621.192,338.474a3.726,3.726,0,0,1-5.546,1.2l-16.16,9.149-3.629-3.848L615.13,334.25a3.72,3.72,0,0,1,6.062,4.224Z",
    transform: "translate(-506.874 -271.978)",
    fill: "#f9735d"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14715",
    "data-name": "Trazado 14715",
    d: "M471.36,360.325l-.172,2.058,22.468-.289,22.365-12.573-3.27-5.032-19.657,8.265-13.971.283A7.952,7.952,0,0,0,471.36,360.325Z",
    transform: "translate(-407.424 -281.296)",
    fill: "#73554a"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14718",
    "data-name": "Trazado 14718",
    d: "M469.566,475.763c-.746-11.076,1.439-21.494,7.507-31.041a2.441,2.441,0,0,1,2.943-1.8l23.443,5.67a2.441,2.441,0,0,1,1.8,2.943l-7.507,31.041a2.441,2.441,0,0,1-2.943,1.8l-23.443-5.67A2.441,2.441,0,0,1,469.566,475.763Z",
    transform: "translate(-406.132 -353.395)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14719",
    "data-name": "Trazado 14719",
    d: "M474.161,478.115a2.441,2.441,0,0,1-1.8-2.943c-.746-11.076,1.439-21.494,7.507-31.041a2.41,2.41,0,0,1,.607-1.094l-.461-.112a2.441,2.441,0,0,0-2.943,1.8c-6.068,9.547-8.254,19.965-7.507,31.041a2.441,2.441,0,0,0,1.8,2.943l23.443,5.67a2.43,2.43,0,0,0,2.336-.7Z",
    transform: "translate(-406.132 -353.395)",
    opacity: 0.2,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14720",
    "data-name": "Trazado 14720",
    d: "M521.447,510.394l-15.72-3.756a.97.97,0,1,1,.451-1.886l15.72,3.756a.97.97,0,0,1-.451,1.886Z",
    transform: "translate(-432.193 -398.741)",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14721",
    "data-name": "Trazado 14721",
    d: "M513.8,488.093l-3.458-.826a.97.97,0,1,1,.445-1.888h.006l3.458.826a.97.97,0,1,1-.451,1.886Z",
    transform: "translate(-435.577 -384.542)",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14722",
    "data-name": "Trazado 14722",
    d: "M514.027,541.448l-15.72-3.756a.97.97,0,1,1,.451-1.886l15.72,3.756a.97.97,0,1,1-.445,1.888Z",
    transform: "translate(-426.755 -421.502)",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14723",
    "data-name": "Trazado 14723",
    d: "M517.734,525.92l-15.72-3.756a.97.97,0,0,1,.448-1.887h0l15.72,3.756a.97.97,0,0,1-.451,1.886Z",
    transform: "translate(-429.471 -410.12)",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_94",
    "data-name": "Elipse 94",
    cx: 4.043,
    cy: 4.043,
    r: 4.043,
    transform: "translate(80.897 88.235)",
    fill: "#3f3d56"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14724",
    "data-name": "Trazado 14724",
    d: "M456.612,530.5a3.258,3.258,0,0,1-.987-4.863l-7.819-14.234,3.406-3.131,9.163,16.974a3.254,3.254,0,0,1-3.762,5.254Z",
    transform: "translate(-393.915 -407.464)",
    fill: "#f9735d"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14725",
    "data-name": "Trazado 14725",
    d: "M421.608,384.522l-6.716-.648a2.258,2.258,0,0,0-2.474,2.247v19.984L424.7,428.63l5.074-3.2-8.012-19.762Z",
    transform: "translate(-364.348 -310.156)",
    fill: "#73554a"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14726",
    "data-name": "Trazado 14726",
    d: "M644.7,297.346c1.557-10.991,5.847-20.733,13.756-28.821a2.441,2.441,0,0,1,3.25-1.15l21.766,10.389a2.441,2.441,0,0,1,1.15,3.25L670.87,309.836a2.441,2.441,0,0,1-3.25,1.15L645.853,300.6A2.441,2.441,0,0,1,644.7,297.346Z",
    transform: "translate(-534.427 -224.602)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14727",
    "data-name": "Trazado 14727",
    d: "M648.712,300.6a2.441,2.441,0,0,1-1.15-3.25c1.557-10.991,5.847-20.733,13.756-28.821a2.409,2.409,0,0,1,.82-.946l-.428-.2a2.441,2.441,0,0,0-3.25,1.15c-7.909,8.088-12.2,17.83-13.756,28.821a2.441,2.441,0,0,0,1.15,3.25l21.766,10.389a2.43,2.43,0,0,0,2.431-.2Z",
    transform: "translate(-534.427 -224.602)",
    opacity: 0.2,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14728",
    "data-name": "Trazado 14728",
    d: "M706.631,336.9l-14.605-6.921a.97.97,0,1,1,.831-1.753l14.605,6.921a.97.97,0,1,1-.831,1.753Z",
    transform: "translate(-568.88 -269.31)",
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14729",
    "data-name": "Trazado 14729",
    d: "M703.76,313.5l-3.213-1.523a.97.97,0,0,1,.825-1.755l.005,0,3.213,1.523a.97.97,0,1,1-.831,1.753Z",
    transform: "translate(-575.123 -256.116)",
    fill: "#fff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14730",
    "data-name": "Trazado 14730",
    d: "M692.958,365.755l-14.605-6.921a.97.97,0,0,1,.831-1.753L693.789,364a.97.97,0,1,1-.825,1.755Z",
    transform: "translate(-558.858 -290.457)",
    fill: "#fff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14731",
    "data-name": "Trazado 14731",
    d: "M699.792,351.328l-14.605-6.921a.97.97,0,1,1,.828-1.754h0l14.605,6.921a.97.97,0,1,1-.831,1.753Z",
    transform: "translate(-563.866 -279.882)",
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_95",
    "data-name": "Elipse 95",
    cx: 4.043,
    cy: 4.043,
    r: 4.043,
    transform: "translate(133.489 43.701)",
    fill: "#3f3d56"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14732",
    "data-name": "Trazado 14732",
    d: "M863.3,325.061a56.489,56.489,0,0,1-4.961-31,2.591,2.591,0,0,1,1.628-2.927l19.854-5.547a1.97,1.97,0,0,1,2.385,1.806l4.961,31a2.591,2.591,0,0,1-1.628,2.927l-19.854,5.547A1.97,1.97,0,0,1,863.3,325.061Z",
    transform: "translate(-690.876 -238.078)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14733",
    "data-name": "Trazado 14733",
    d: "M867.62,340.181a1.97,1.97,0,0,1-2.386-1.806,56.489,56.489,0,0,1-4.961-31,2.864,2.864,0,0,1,.086-1.247l-.391.109a2.591,2.591,0,0,0-1.628,2.927,56.49,56.49,0,0,0,4.961,31,1.97,1.97,0,0,0,2.386,1.806l19.854-5.547a2.359,2.359,0,0,0,1.542-1.68Z",
    transform: "translate(-690.876 -253.181)",
    opacity: 0.2,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14734",
    "data-name": "Trazado 14734",
    d: "M898.923,348.983l-13.3,3.76a.782.782,0,0,1-.95-.716,1.03,1.03,0,0,1,.644-1.165l13.3-3.76a.783.783,0,0,1,.949.719,1.031,1.031,0,0,1-.643,1.163Z",
    transform: "translate(-710.473 -283.192)",
    fill: "#fff"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14735",
    "data-name": "Trazado 14735",
    d: "M885.4,340.649l-2.925.827a.781.781,0,0,1-.953-.711,1.031,1.031,0,0,1,.642-1.169h.005l2.925-.827a.783.783,0,0,1,.949.719,1.03,1.03,0,0,1-.643,1.163Z",
    transform: "translate(-708.163 -277.084)",
    fill: "#fff"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14736",
    "data-name": "Trazado 14736",
    d: "M903.96,379.949l-13.3,3.76a.783.783,0,0,1-.949-.719,1.031,1.031,0,0,1,.643-1.163l13.3-3.76a.781.781,0,0,1,.953.711,1.031,1.031,0,0,1-.642,1.169Z",
    transform: "translate(-714.166 -305.887)",
    fill: "#fff"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14737",
    "data-name": "Trazado 14737",
    d: "M901.434,364.468l-13.3,3.76a.782.782,0,0,1-.951-.714,1.031,1.031,0,0,1,.644-1.167h0l13.3-3.76a.783.783,0,0,1,.949.719,1.03,1.03,0,0,1-.643,1.163Z",
    transform: "translate(-712.312 -294.542)",
    fill: "#fff"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_96",
    "data-name": "Elipse 96",
    cx: 4.043,
    cy: 3.375,
    rx: 4.043,
    ry: 3.375,
    transform: "translate(174.616 54.084) rotate(-82.638)",
    fill: "#3f3d56"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_568",
    "data-name": "Grupo 568",
    transform: "translate(53.891 40.574)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_388",
    "data-name": "Trazado 388",
    d: "M163.852,171.262s4.3-1.379,4.322,1.852c.027,3.743-4.408,3.364-4.408,3.364Z",
    transform: "translate(-150.286 -156.047)",
    fill: "#f27e64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_389",
    "data-name": "Trazado 389",
    d: "M171.024,184.715a.264.264,0,0,0,.215-.11l1.6-2.236a.264.264,0,1,0-.429-.307l-1.6,2.236a.264.264,0,0,0,.214.417",
    transform: "translate(-155.689 -165.95)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_390",
    "data-name": "Trazado 390",
    d: "M171.483,198.339a.264.264,0,0,0,.029-.526l-1.178-.13a.264.264,0,0,0-.058.524l1.178.13.029,0",
    transform: "translate(-154.476 -180.133)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_391",
    "data-name": "Trazado 391",
    d: "M214.709,249.76l-.44,4.337a9.185,9.185,0,0,0,3.683,1.29c2.824.312,3.934-1.277,3.934-1.277l.454-5.091Z",
    transform: "translate(-209.418 -226.423)",
    fill: "#f27e64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_392",
    "data-name": "Trazado 392",
    d: "M210.626,253.861s1.027,3.64,4.283,3.46c2.624-.145,3.706-3.746,3.706-3.746Z",
    transform: "translate(-205.335 -230.53)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_393",
    "data-name": "Trazado 393",
    d: "M203.973,104.213s1.072,8.114-1.532,11.42a5.386,5.386,0,0,1-7.983.784,6.668,6.668,0,0,1-2.051-3.865s-2.778.289-3.48-2.02a3.079,3.079,0,0,1,2.512-4.136c1.374.016,1.51.279,1.51.279l-.168-2.532s9.153-8.444,11.19.07",
    transform: "translate(-188.763 -92.426)",
    fill: "#f27e64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_394",
    "data-name": "Trazado 394",
    d: "M310.348,177.314a.264.264,0,0,0,.189-.447l-1.936-2a.264.264,0,0,0-.379.367l1.936,2a.263.263,0,0,0,.189.08",
    transform: "translate(-306.921 -159.488)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_395",
    "data-name": "Trazado 395",
    d: "M314.976,189.7a.264.264,0,0,0,.138-.039l1.329-.818a.264.264,0,0,0-.276-.449l-1.33.818a.264.264,0,0,0,.138.488",
    transform: "translate(-313.523 -171.719)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_396",
    "data-name": "Trazado 396",
    d: "M264.127,164.908a.264.264,0,0,0,.263-.255l.046-1.344a.263.263,0,0,0-.254-.272.257.257,0,0,0-.272.254l-.046,1.344a.263.263,0,0,0,.254.272h.009",
    transform: "translate(-256.391 -148.893)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_397",
    "data-name": "Trazado 397",
    d: "M211.827,166.918a.263.263,0,0,0,.263-.255l.047-1.344a.263.263,0,0,0-.254-.272.26.26,0,0,0-.272.254l-.047,1.344a.263.263,0,0,0,.254.272h.009",
    transform: "translate(-198.95 -150.707)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_398",
    "data-name": "Trazado 398",
    d: "M236.732,178.412a.264.264,0,0,0,.253-.189,7.5,7.5,0,0,0,.078-3.928.264.264,0,0,0-.506.15,7.089,7.089,0,0,1-.078,3.628.264.264,0,0,0,.178.328.261.261,0,0,0,.075.011",
    transform: "translate(-226.546 -158.875)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_399",
    "data-name": "Trazado 399",
    d: "M204.373,146.172a.264.264,0,0,0,.191-.446,2.692,2.692,0,0,0-1.543-.645.264.264,0,0,0-.041.526,2.191,2.191,0,0,1,1.2.483.263.263,0,0,0,.191.082",
    transform: "translate(-190.581 -132.704)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_400",
    "data-name": "Trazado 400",
    d: "M255.194,148.306a.261.261,0,0,0,.133-.036,2.2,2.2,0,0,1,1.29-.131.264.264,0,0,0,.106-.517,2.694,2.694,0,0,0-1.662.193.264.264,0,0,0,.133.491",
    transform: "translate(-248.009 -134.948)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_401",
    "data-name": "Trazado 401",
    d: "M298.5,147.277s.629,2.53.955,2.459.153-3.984-.756-4.226-.2,1.766-.2,1.766",
    transform: "translate(-294.944 -133.073)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_402",
    "data-name": "Trazado 402",
    d: "M245.779,224.2a.264.264,0,0,0,.01-.527,2.219,2.219,0,0,1-1.846-1.174.264.264,0,0,0-.48.218,2.751,2.751,0,0,0,2.305,1.483h.01",
    transform: "translate(-235.989 -202.369)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_403",
    "data-name": "Trazado 403",
    d: "M168.587,74.51a10.021,10.021,0,0,0,4.68-1.46,7.116,7.116,0,0,0,2.294-2.838,4.854,4.854,0,0,1,2.838,1.014c1.645,1.114,1.638,4.332,1.638,4.332s3.362-5.306,1.958-7.3-3.909-.5-3.909-.5.587-3.54-4.4-2.378a8.67,8.67,0,0,0-6.3,5.364,1.71,1.71,0,0,0-1.951,1.327,7.125,7.125,0,0,0,.289,3.16,1.825,1.825,0,0,1,1.868-.2l1.106.466Z",
    transform: "translate(-164.607 -60.633)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_406",
    "data-name": "Trazado 406",
    d: "M161.623,96.472a2.665,2.665,0,0,1,1.755,1.354,1.584,1.584,0,0,1,.1.756,1.852,1.852,0,0,1-.4.859c-1.224,1.463-6.254,1.341-6.254,1.341-3.375-.082-5.165-.316-7.966-.44-1.572-.07-2.913-.08-3.912-.072a.077.077,0,0,1-.016-.152l16.7-3.646",
    transform: "translate(-143.74 -88.875)",
    fill: "#c6783a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_407",
    "data-name": "Trazado 407",
    d: "M294.69,135.3l-2.579,2.9a3.019,3.019,0,0,0-2.1.56,2.5,2.5,0,0,0-.365.353l-.23-.249a.681.681,0,0,1,.019-.944l2.705-2.7Z",
    transform: "translate(-289.139 -123.811)",
    fill: "#fae8dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_408",
    "data-name": "Trazado 408",
    d: "M163.808,29.676a.865.865,0,0,0,.91.889c1.894-.1,3.489-.22,4.7-.328,3.091-.274,1.831-.278,5.453-.653,2.418-.251,3.666-.32,4.946-1.257a5.883,5.883,0,0,0,1.436-1.527,9.231,9.231,0,0,0-3.811-6.118,8.963,8.963,0,0,0-5.811-1.437,8.726,8.726,0,0,0-3.51,1.317c-3.694,2.431-4.253,7.094-4.315,9.113",
    transform: "translate(-163.373 -19.203)",
    fill: "#f2b05b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_409",
    "data-name": "Trazado 409",
    d: "M223.7,37.509a7.914,7.914,0,0,1,6.705-.5,7.281,7.281,0,0,1,3.187,2.71,5.776,5.776,0,0,0-2.6-3.961,5.636,5.636,0,0,0-5.658-.037,3.186,3.186,0,0,0-1.637,1.784",
    transform: "translate(-221.597 -33.43)",
    fill: "#c6783a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialogPerson);
export default __webpack_public_path__ + "static/media/dialogPerson.c80323ca62836f7c8cd864b1cfc4b39b.svg";
export { ForwardRef as ReactComponent };